module.exports = __webpack_public_path__ + "static/media/404.3c60e090.png";